var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.14 50H7.057C3.577 50 .74 47.197.74 43.756V6.27C.74 2.829 3.576.025 7.057.025H165.14c3.482 0 6.317 2.804 6.317 6.244v37.487c0 3.44-2.861 6.244-6.317 6.244z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.14.997c2.94 0 5.312 2.344 5.312 5.25v37.487c0 2.905-2.372 5.25-5.312 5.25H7.057c-2.939 0-5.311-2.345-5.311-5.25V6.247c0-2.906 2.372-5.25 5.311-5.25H165.14zm0-.994H7.057C3.577.003.74 2.806.74 6.247v37.487c0 3.44 2.837 6.243 6.317 6.243H165.14c3.481 0 6.317-2.803 6.317-6.243V6.247c0-3.44-2.861-6.244-6.317-6.244z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.693 12.819c0 1.044-.31 1.885-.928 2.497-.722.74-1.65 1.121-2.785 1.121-1.083 0-2.037-.382-2.785-1.12-.773-.765-1.16-1.683-1.16-2.804 0-1.121.387-2.039 1.16-2.778.774-.739 1.702-1.121 2.785-1.121.542 0 1.057.102 1.547.306.49.203.903.484 1.186.84l-.67.663c-.516-.586-1.186-.892-2.089-.892-.799 0-1.495.28-2.062.841-.594.56-.877 1.274-.877 2.166 0 .892.283 1.606.877 2.166.593.561 1.289.841 2.062.841.851 0 1.547-.28 2.115-.84.36-.357.593-.867.644-1.53h-2.759v-.892h3.662c.077.153.077.332.077.536zm5.831-3.135h-3.455v2.37h3.12v.892h-3.12v2.37h3.455v.918h-4.435V8.74h4.435v.943zm4.117 6.575h-.98V9.684h-2.114v-.917h5.209v.917H70.64v6.575zm5.881 0V8.767h.98v7.492h-.98zm5.311 0h-.98V9.684H78.74v-.917h5.209v.917h-2.115v6.575zm11.992-.969c-.747.765-1.676 1.147-2.785 1.147-1.109 0-2.037-.382-2.784-1.147-.748-.764-1.109-1.682-1.109-2.777 0-1.096.361-2.04 1.109-2.778.747-.765 1.675-1.147 2.784-1.147 1.11 0 2.038.382 2.785 1.147.748.764 1.135 1.682 1.135 2.777-.026 1.096-.387 2.014-1.135 2.778zm-4.847-.637c.567.56 1.237.841 2.062.841.8 0 1.496-.28 2.063-.84.568-.562.85-1.275.85-2.167 0-.892-.282-1.605-.85-2.166-.567-.56-1.238-.841-2.063-.841-.825 0-1.495.28-2.062.84-.568.562-.851 1.275-.851 2.167 0 .892.283 1.605.85 2.166zm7.318 1.606V8.767h1.187l3.687 5.835h.051l-.051-1.452V8.767h.98v7.492h-1.006l-3.867-6.116h-.052l.052 1.452v4.664h-.98z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.199,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.893 27.192c-2.966 0-5.39 2.242-5.39 5.326 0 3.058 2.424 5.326 5.39 5.326 2.965 0 5.414-2.268 5.414-5.326 0-3.084-2.423-5.326-5.414-5.326zm0 8.537c-1.625 0-3.043-1.325-3.043-3.211 0-1.911 1.393-3.211 3.043-3.211 1.65 0 3.042 1.3 3.042 3.211 0 1.886-1.418 3.211-3.042 3.211zm-11.758-8.537c-2.965 0-5.389 2.242-5.389 5.326 0 3.058 2.424 5.326 5.389 5.326 2.965 0 5.389-2.268 5.389-5.326 0-3.084-2.424-5.326-5.389-5.326zm0 8.537c-1.624 0-3.043-1.325-3.043-3.211 0-1.911 1.419-3.211 3.043-3.211s3.042 1.3 3.042 3.211c-.025 1.886-1.418 3.211-3.042 3.211zm-14.027-6.906v2.268h5.467c-.155 1.274-.593 2.192-1.238 2.829-.8.79-2.037 1.656-4.229 1.656-3.351 0-5.981-2.676-5.981-5.989 0-3.313 2.63-5.988 5.981-5.988 1.805 0 3.146.713 4.126 1.605l1.599-1.58c-1.367-1.3-3.172-2.268-5.725-2.268-4.615 0-8.482 3.695-8.482 8.257 0 4.562 3.867 8.257 8.482 8.257 2.502 0 4.358-.816 5.828-2.32 1.495-1.477 1.985-3.593 1.985-5.275 0-.535-.052-1.019-.129-1.401 0-.051-7.684-.051-7.684-.051zm57.293 1.758c-.439-1.197-1.805-3.39-4.615-3.39-2.759 0-5.08 2.167-5.08 5.327 0 2.982 2.269 5.326 5.338 5.326 2.475 0 3.893-1.478 4.485-2.344l-1.83-1.198c-.619.892-1.444 1.478-2.655 1.478-1.187 0-2.064-.535-2.605-1.605l7.194-2.931c.026-.077-.232-.663-.232-.663zm-7.322 1.759c-.052-2.04 1.598-3.11 2.809-3.11.929 0 1.728.46 2.012 1.122-.026.025-4.821 1.988-4.821 1.988zm-5.854 5.173h2.372V21.89h-2.372v15.622zm-3.867-9.149h-.078c-.542-.611-1.547-1.172-2.836-1.172-2.681 0-5.157 2.344-5.157 5.326 0 2.982 2.475 5.3 5.157 5.3 1.289 0 2.294-.56 2.836-1.197h.078v.764c0 2.04-1.109 3.135-2.862 3.135-1.444 0-2.347-1.02-2.708-1.886l-2.062.841c.593 1.402 2.165 3.135 4.77 3.135 2.784 0 5.105-1.606 5.105-5.53v-9.557h-2.243v.841zM98.65 35.73c-1.624 0-2.991-1.35-2.991-3.211 0-1.886 1.367-3.236 2.991-3.236 1.599 0 2.862 1.376 2.862 3.236 0 1.86-1.263 3.211-2.862 3.211zm30.838-13.863h-5.647v15.621h2.346v-5.912h3.301c2.63 0 5.182-1.886 5.182-4.842 0-2.982-2.578-4.867-5.182-4.867zm.052 7.543h-3.353v-5.352h3.353c1.753 0 2.758 1.453 2.758 2.676 0 1.198-1.005 2.676-2.758 2.676zm14.594-2.243c-1.702 0-3.481.74-4.204 2.396l2.09.866c.438-.866 1.289-1.146 2.165-1.146 1.212 0 2.476.739 2.476 2.013v.153c-.439-.255-1.341-.612-2.476-.612-2.243 0-4.564 1.223-4.564 3.517 0 2.09 1.857 3.44 3.919 3.44 1.599 0 2.476-.713 3.017-1.529h.078v1.198h2.269v-5.989c.025-2.752-2.063-4.307-4.77-4.307zm-.284 8.563c-.773 0-1.856-.382-1.856-1.325 0-1.198 1.34-1.682 2.501-1.682 1.031 0 1.521.23 2.166.535-.207 1.453-1.444 2.472-2.811 2.472zm13.382-8.231l-2.707 6.778h-.078l-2.81-6.778h-2.553l4.203 9.454-2.398 5.276h2.475l6.498-14.73h-2.63zM135.96 37.513h2.372V21.89h-2.372v15.622z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.921 9.43c-.36.381-.593.993-.593 1.758v27.65c0 .764.207 1.376.593 1.758l.103.077 15.677-15.495v-.357L14.024 9.328l-.103.102z",
    fill: "url(#paint0_linear_2490_5186)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.914 30.351l-5.208-5.173v-.357l5.234-5.173.129.076 6.188 3.492c1.753.994 1.753 2.625 0 3.618L35.069 30.3c-.026-.025-.155.051-.155.051z",
    fill: "url(#paint1_linear_2490_5186)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.036 30.275L29.698 25 13.944 40.57c.593.612 1.547.689 2.63.077l18.462-10.372z",
    fill: "url(#paint2_linear_2490_5186)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.031 19.724L16.544 9.352c-1.083-.611-2.037-.535-2.63.077l15.754 15.57 5.363-5.274z",
    fill: "url(#paint3_linear_2490_5186)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2490_5186",
    x1: 28.295,
    y1: 39.115,
    x2: 2.325,
    y2: 12.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2490_5186",
    x1: 43.521,
    y1: 25.001,
    x2: 5.178,
    y2: 25.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2490_5186",
    x1: 21.569,
    y1: 32.562,
    x2: -13.649,
    y2: -3.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2490_5186",
    x1: -0.602,
    y1: 39.352,
    x2: 15.125,
    y2: 23.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayBtn);
export default __webpack_public_path__ + "static/media/googleplay-btn.1339418d80f0bd0bf755cf52017c044c.svg";
export { ForwardRef as ReactComponent };